import {
  DEFAULT_SUPPORTED_BLOCKCHAIN_IDS
} from "../chunk-5XH3SWXK.js";

// src/solana/BlinkSolanaConfig.ts
import { Connection } from "@solana/web3.js";
var BlinkSolanaConfig = class _BlinkSolanaConfig {
  constructor(rpcUrlOrConnection, adapter) {
    this.adapter = adapter;
    if (!rpcUrlOrConnection) {
      throw new Error("rpcUrl or connection is required");
    }
    this.connection = typeof rpcUrlOrConnection === "string" ? new Connection(rpcUrlOrConnection, "confirmed") : rpcUrlOrConnection;
  }
  static CONFIRM_TIMEOUT_MS = 6e4 * 1.2;
  // 20% extra time
  static DEFAULT_METADATA = {
    supportedBlockchainIds: DEFAULT_SUPPORTED_BLOCKCHAIN_IDS
  };
  connection;
  get metadata() {
    return this.adapter.metadata ?? _BlinkSolanaConfig.DEFAULT_METADATA;
  }
  signTransaction(tx, context) {
    return this.adapter.signTransaction(tx, context);
  }
  confirmTransaction(signature) {
    return new Promise((res, rej) => {
      const start = Date.now();
      const confirm = async () => {
        if (Date.now() - start >= _BlinkSolanaConfig.CONFIRM_TIMEOUT_MS) {
          rej(new Error("Unable to confirm transaction: timeout reached"));
          return;
        }
        try {
          const status = await this.connection.getSignatureStatus(signature);
          if (status.value?.err) {
            rej(
              new Error(
                `Transaction execution failed, check wallet for details`
              )
            );
            return;
          }
          if (status.value && status.value.confirmations !== null) {
            res();
            return;
          }
        } catch (e) {
          console.error(
            "[@dialectlabs/blinks-core] Error confirming transaction",
            e
          );
        }
        setTimeout(confirm, 3e3);
      };
      confirm();
    });
  }
  async signMessage(data, context) {
    return this.adapter.signMessage(data, context);
  }
  async connect(context) {
    try {
      return await this.adapter.connect(context);
    } catch {
      return null;
    }
  }
};
export {
  BlinkSolanaConfig as ActionConfig,
  BlinkSolanaConfig
};
